import actionTypes from './actionTypes';

export const updateBannerHeight = (payload) => ({
    type: actionTypes.UPDATE_BANNER_HEIGHT,
    payload,
});
